module.exports = __webpack_public_path__ + "static/media/black-bg.202a6d0b.png";